const validatePassword = val => {
  const r = /^[0-9a-zA-Z!@#$%^&*_`()\-+=.]{8,20}$/; // 特殊字符可以补充，与后续校验同步即可
  let s = 0;
  if (r.test(val)) {
    const a = /[0-9]/.exec(val) !== null ? 1 : 0;
    const b = /[a-zA-Z]/.exec(val) !== null ? 1 : 0;
    const c = /[!@#$%^&*_`()\-+=.]/.exec(val) !== null ? 1 : 0;

    s = a + b + c;
    if (s > 1) {
      return true;
    }
  }
  return false;
};

export default validatePassword;
